// vorvani-variant-fix.js
// Fixes variant price + URL update for the Shrine theme on VORVANI.
// Root cause: the product-info custom element is not registered in this
// theme build, so variant change events go unhandled. This script
// subscribes to the Shrine pub/sub system and performs the updates manually.
//
// BUG FIX 1 (Sep 2026): getCheckedOptions solo leia inputs tipo radio,
// ignorando los <select> dropdown. Productos con opciones mixtas
// (Talla=pills + Color=dropdown) solo devolvian 1 valor en vez de 2,
// haciendo que findVariant no encontrara ninguna variante y el formulario
// quedara bloqueado en la variante predeterminada (S).
//
// BUG FIX 2 (Sep 2026): updatePriceContainer no actualizaba el badge
// "Ahorrara $X" (.price__badge-sale .nowrap). Al cambiar de variante,
// el badge siempre mostraba el ahorro de la S en vez del ahorro real.

(function () {
  'use strict';

  function init() {
    // Wait until Shrine's pub/sub helpers are defined (deferred scripts)
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(init, 50);
      return;
    }

    // Grab the variant data Shrine embeds on every product page
    var variantScript = Array.from(
      document.querySelectorAll('script[type="application/json"]')
    ).find(function (s) {
      return s.textContent.indexOf('"option1"') > -1;
    });
    if (!variantScript) return;

    var variants;
    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (e) {
      return;
    }

    // Format cents -> "$ 499 MXN" (no trailing .00 for whole numbers)
    function formatMoney(cents) {
      var amount = cents / 100;
      var formatted = Number.isInteger(amount)
        ? String(amount)
        : amount.toFixed(2);
      return '$ ' + formatted + ' MXN';
    }

    // Format cents -> "$ 300" (savings badge format, without MXN suffix)
    function formatSavings(cents) {
      var amount = cents / 100;
      var formatted = Number.isInteger(amount)
        ? String(amount)
        : amount.toFixed(2);
      return '$ ' + formatted;
    }

    // Get all currently-selected option values from the variant selector.
    // FIXED: Handles BOTH radio inputs (pills/swatches) AND <select> dropdowns
    // so that mixed-type products (e.g. Talla=pills + Color=dropdown) work.
    function getCheckedOptions(vsEl) {
      if (!vsEl) return [];

      // Radio buttons (pills / swatches type)
      var radioValues = Array.from(
        vsEl.querySelectorAll('input[type="radio"]:checked')
      ).map(function (el) {
        return el.value;
      });

      // <select> dropdowns (dropdown type) - these were previously missed!
      var selectValues = Array.from(
        vsEl.querySelectorAll('select.select__select')
      ).map(function (el) {
        return el.value;
      }).filter(Boolean);

      return radioValues.concat(selectValues);
    }

    // Find the variant whose options exactly match the selection
    function findVariant(selectedValues) {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(Boolean);
        return (
          opts.length === selectedValues.length &&
          selectedValues.every(function (val) {
            return opts.indexOf(val) > -1;
          })
        );
      });
    }

    // Update all price spans + savings badge inside a price block container
    function updatePriceContainer(container, variant) {
      if (!container) return;
      var salePrice = variant.price;
      var comparePrice = variant.compare_at_price;

      // Sale price (shown when price < compare_at_price)
      Array.from(
        container.querySelectorAll('.price-item--sale.price-item--last')
      ).forEach(function (el) {
        el.textContent = formatMoney(salePrice);
      });

      // Regular price (shown when no discount)
      Array.from(
        container.querySelectorAll('.price__regular .price-item--regular')
      ).forEach(function (el) {
        el.textContent = formatMoney(salePrice);
      });

      // Compare-at price (strikethrough original price)
      Array.from(
        container.querySelectorAll('.price__compare-price .price-item')
      ).forEach(function (el) {
        if (comparePrice) el.textContent = formatMoney(comparePrice);
      });

      // FIX 2: Savings badge ("Ahorrara $ 300")
      // The badge text lives in .price__badge-sale .nowrap
      // We replace the monetary amount inside that text (e.g. "$ 300" -> "$ 270")
      // preserving the surrounding label set by settings.sale_badge_text.
      var nowrapEl = container.querySelector('.price__badge-sale .nowrap');
      if (nowrapEl && comparePrice && comparePrice > salePrice) {
        var savingsCents = comparePrice - salePrice;
        nowrapEl.textContent = nowrapEl.textContent.replace(
          /\$\s*[\d,.]+/,
          formatSavings(savingsCents)
        );
      }
    }

    // Push the selected variant into the browser URL without reloading
    function updateURL(variantId) {
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }
    }

    // FIX: cart-drawer compare price
    function fixCartDrawerComparePrices() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) return;

          var handles = {};
          cart.items.forEach(function (item) { handles[item.handle] = true; });

          return Promise.all(
            Object.keys(handles).map(function (handle) {
              return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
            })
          ).then(function (products) {
            var compareMap = {};
            products.forEach(function (product) {
              (product.variants || []).forEach(function (v) {
                compareMap[v.id] = v.compare_at_price || 0;
              });
            });

            var itemEls = document.querySelectorAll(
              'cart-drawer-items .cart-drawer-item, ' +
              '#CartDrawer-CartItems .cart-item'
            );

            cart.items.forEach(function (item, idx) {
              var comparePrice = compareMap[item.variant_id];
              if (!comparePrice || comparePrice <= item.price) return;

              var el = itemEls[idx];
              if (!el) return;

              var sEl = el.querySelector('.cart-item__old-price');
              if (sEl) {
                sEl.textContent = formatMoney(comparePrice);
              }
            });

            var totalCompare = 0;
            var totalFinal   = cart.total_price;
            cart.items.forEach(function (item) {
              var cp = compareMap[item.variant_id] || 0;
              totalCompare += (cp > item.price ? cp : item.price) * item.quantity;
            });
            var savings = totalCompare - totalFinal;

            if (savings > 0) {
              document.querySelectorAll(
                '.cart-drawer__savings, .cart-savings, [class*="saving"]'
              ).forEach(function (el) {
                if (/ahorras|save|savings/i.test(el.textContent)) {
                  el.textContent = 'Te ahorras ' + formatMoney(savings);
                }
              });
            }
          });
        })
        .catch(function (e) {
          console.error('[VORVANI cart drawer fix]', e);
        });
    }

    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      var drawerObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            if (cartDrawerEl.classList.contains('active')) {
              setTimeout(fixCartDrawerComparePrices, 150);
            }
          }
        });
      });
      drawerObserver.observe(cartDrawerEl, { attributes: true });
    }

    var cartEvents = ['cart:refresh', 'cart:updated', 'cartUpdate'];
    cartEvents.forEach(function (evtName) {
      if (PUB_SUB_EVENTS[evtName]) {
        subscribe(PUB_SUB_EVENTS[evtName], function () {
          setTimeout(fixCartDrawerComparePrices, 300);
        });
      }
    });

    document.addEventListener('cart-drawer:open', function () {
      setTimeout(fixCartDrawerComparePrices, 150);
    });
    document.addEventListener('cart:refresh', function () {
      setTimeout(fixCartDrawerComparePrices, 300);
    });

    // Subscribe to Shrine's option-change event
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
      try {
        var vsEl = document.querySelector('variant-selects');
        if (!vsEl) return;

        // FIXED: now also reads <select> dropdowns, not just radio inputs
        var selected = getCheckedOptions(vsEl);

        // Fallback: use the event target's value directly (single-option products)
        if (!selected.length && event && event.data && event.data.target) {
          selected = [event.data.target.value];
        }
        if (!selected.length) return;

        var variant = findVariant(selected);
        if (!variant) return;

        // Main product price block (updates price + savings badge)
        updatePriceContainer(
          document.querySelector('[id^="price-template"]') ||
            document.querySelector('[id^="price-"]'),
          variant
        );

        // Sticky ATC price bar
        updatePriceContainer(
          document.querySelector('[id^="sticky-atc-separate-price"]'),
          variant
        );

        // Update browser URL
        updateURL(variant.id);

        // Update the product form's hidden id input so the
        // correct variant actually gets added to cart
        var idInputs = document.querySelectorAll(
          'product-form input[name="id"], ' +
          'form[action*="/cart/add"] input[name="id"]'
        );
        idInputs.forEach(function (input) {
          input.value = variant.id;
        });

        // Also update the quantity-break / bundle form if present
        var bundleForm = document.querySelector(
          '.bundle-form input[name="id"], ' +
          '#bundle-atc-form input[name="id"]'
        );
        if (bundleForm) bundleForm.value = variant.id;

      } catch (e) {
        console.error('[VORVANI variant fix]', e);
      }
    });
  }

  // Run after DOM is ready (Shrine's deferred scripts run before DOMContentLoaded)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
